import React from 'react'
import {PROPOSAL_DETAIL, VOTES} from "../constants/proposals";
import AppLabel from "../components/label";
import {Col, Divider, Row, Space} from "antd";
import AboutGameCard from "../components/about_game";
import AppButton from "../components/button";

const DetailPage = ({
    type = 'Voting',
...props
})=>{

    var data = PROPOSAL_DETAIL



    return (
        <div>
            <div className={'font-xxl bold'}>
                {
                    data.title
                }
            </div>
            {data.owner_address}
            <br/>
            <AppLabel text={type} className={'margin-sm-y'} />
            <br/>
            <Row justify={'space-between'}>
            <Col span={14}>
                <h3>
                    DESCRIPTION
                </h3>
                {
                    data.description
                }
            </Col>
                <Col span={8}>
                    <AboutGameCard
                    items={[
                        {
                            name:'Submitted Date',
                            value: data.submitted_date
                        },
                        {
                            name: 'Github link',
                            value: data.github_url
                        },
                        {
                            name: 'Votes',
                            value: data.votes
                        }
                    ]}
                    />
                    <br/>
                    {
                        type?.toLowerCase()=='voting' &&
                            <Row justify={'center'}>
                                <AppButton glow style={{width:120}}

                                >
                                    VOTE
                                </AppButton>
                            </Row>
                    }
                </Col>
            </Row>
            <Divider />
            <h3>
                {
                    type?.toLowerCase()=='voting' &&
                        VOTES.map((vote)=><Row justify={'space-between'} className={'padding'} >

                                    <Space size={20}>{vote.address} <AppLabel text={vote.vote}/></Space>
                                    <div>
                                        {vote.timestamp}
                                        </div>

                            </Row>
                                )
                }
            </h3>
        </div>
    )
}

export default DetailPage